// @flow
import type {Node, Edge, Element, NodeChildren, NodeAttributes} from '../types';

const buildOverviewDiagramNode = (
  attributes: NodeAttributes,
  children: NodeChildren,
): Node => {
  const {id, icon} = attributes;
  const type = icon ? 'icon' : 'text';
  return {
    id,
    type,
    data: {icon, text: children},
    position: {x: 0, y: 0},
  };
};

const buildOverviewDiagramEdge = (
  attributes: NodeAttributes,
  children: NodeChildren,
): Edge => {
  const {from, to} = attributes;
  return {
    id: `edge-${from}-${to}`,
    source: from,
    target: to,
    arrowHeadType: 'arrowclosed',
  };
};

export const buildOverviewDiagram = (
  attributes: NodeAttributes,
  children: NodeChildren | null,
): Array<Element> => {
  if (!children) {
    return [];
  }
  const elements = children.map((c) => {
    if (c.name !== 'node' && c.name !== 'edge') {
      // We should never get here due to Markdoc tag validation
      return null;
    }
    return c.name === 'node'
      ? buildOverviewDiagramNode(c.attributes, c.children)
      : buildOverviewDiagramEdge(c.attributes, c.children);
  });
  return elements.filter(Boolean);
};
